const state = {
    wallet: { balance: 0 },
};

const getters = {
    getWalletData(state){
        return state.wallet;
    }
};

const mutations = {
    setWalletData(state, data){
        state.wallet = data;
    }
};

const actions = {
    getWalletDataFromApi({ commit }){
        commit("setWalletData", { balance: 0 });
        return Promise.resolve();
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}